import dayjs from 'dayjs';
import { Tag } from 'antd';
import React from 'react';

import { TableActions } from '../components/TableActions';
import { PromocodeDTO } from '../service/promocodes.interface';

export const getColumns = () => {
    return [
        {
            title: 'Промокод',
            dataIndex: 'code',
            render: (code: string) => code,
        },
        {
            title: 'Скидка',
            dataIndex: 'discount',
            render: (discount: number) => `${discount}%`,
            sorter: (a, b) => a.discount - b.discount,
        },
        {
            title: 'Кол-во использований',
            dataIndex: 'usage_limit',
            render: (usage_limit: number) => usage_limit,
            sorter: (a, b) => a.usage_limit - b.usage_limit,
        },
        {
            title: 'Активен до',
            dataIndex: 'end_date',
            render: (end_date: Date) => dayjs(end_date).format('DD.MM.YYYY'),
            sorter: (a, b) =>
                dayjs(a.end_date).unix() - dayjs(b.end_date).unix(),
        },
        {
            title: 'Статус',
            dataIndex: 'is_active',
            render: (isActive: boolean) => (
                <Tag>{isActive ? 'Активен' : 'Не активен'}</Tag>
            ),
            sorter: (a, b) => a.isActive - b.isActivet,
        },
        {
            render: (record: PromocodeDTO) => <TableActions record={record} />,
        },
    ];
};
